module.exports = __webpack_public_path__ + "img/luhe.5e4eede0.webp";